<app-custom-feedback
  *ngIf="globalFeedbackFlag"
  [feedbackTitle]="globalFeedbackData?.feedbackTitle"
  [tickIcon]="globalFeedbackData?.tickIcon"
  [feedbackBody]="globalFeedbackData?.feedbackBody"
  [feedbackBtn]="globalFeedbackData?.feedbackBtn"
  (dimissFeedbackBtn)="dimissFeedbackBtn($event)"
></app-custom-feedback>
<router-outlet></router-outlet>
